import React, { useState } from 'react';
import {
  HeadingText,
  BodyText,
  Card,
  HorizontalScroll,
} from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';
import styles from './valuePropsCarousel.less';

const ValuePropsCarousel = (props) => {
  const { headline, cardContent } = props;

  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (index) => {
    setCurrentPage(index);
  };

  const renderCard = (item) => {
    return (
      item.pictogram &&
      item.header &&
      item.description && (
        <Card key='card' className={styles.card}>
          <Card.Content>
            <p>
              <img
                alt=''
                role='presentation'
                src={item.pictogram}
                className={styles.pictogram}
              />
            </p>
            <br />
            <HeadingText size='sm'>{item.header}</HeadingText>
            <br />
            <BodyText>{item.description}</BodyText>
          </Card.Content>
        </Card>
      )
    );
  };

  return (
    <div className={styles.container}>
      <MediaQuery maxWidth={600}>
        <BodyText className={styles.headline}>{headline}</BodyText>
        <HorizontalScroll
          items={cardContent}
          renderItem={renderCard}
          numOfVisibleItems={1}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </MediaQuery>
      <MediaQuery maxWidth={900} minWidth={601}>
        <HeadingText size='sm' className={styles.headline}>
          {headline}
        </HeadingText>
        <HorizontalScroll
          items={cardContent}
          renderItem={renderCard}
          numOfVisibleItems={2}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </MediaQuery>
      <MediaQuery minWidth={901}>
        <HeadingText size='lg' className={styles.headline}>
          {headline}
        </HeadingText>
        <HorizontalScroll
          items={cardContent}
          renderItem={renderCard}
          numOfVisibleItems={3}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      </MediaQuery>
    </div>
  );
};

ValuePropsCarousel.propTypes = {
  cardContent: PropTypes.array.isRequired,
  headline: PropTypes.string,
};
export default ValuePropsCarousel;
